/**
 * @generated SignedSource<<990fb120084d8d44896fd17c3b42ad20>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroCarousel_viewer">;
  readonly " $fragmentType": "HpSharedHeroModule_viewer";
};
export type HpSharedHeroModule_viewer$key = {
  readonly " $data"?: HpSharedHeroModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroModule_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedHeroCarousel_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9a4b130f4c5ee43f8d23d62ec4f94b3e";

export default node;
